var HttpDebugger = /** @class */ (function () {
    function HttpDebugger() {
    }
    /*
    Called when http request is started
    */
    HttpDebugger.prototype.debugStartHttpRequest = function () {
    };
    /*
    Called when http request is resolved
    */
    HttpDebugger.prototype.debugSuccessHttpRequest = function () {
    };
    /*
    Called when http request is being retried
    */
    HttpDebugger.prototype.debugRetryHttpRequest = function () {
    };
    return HttpDebugger;
}());
export { HttpDebugger };
export var httpDebugger = new HttpDebugger();
//# sourceMappingURL=http.debugger.js.map